import { Platform } from 'react-native';
import { useMediaQuery } from 'react-responsive';

/**
 * Whether the grid is arranged by touch (a tablet, an app build) rather
 * than a mouse on the web. A touch drag or resize starts only after a
 * short hold, so a scroll that begins on a handle stays a scroll and never
 * turns a preset layout into a custom one by accident.
 */
export function useArrangesByTouch(): boolean {
  const fine = useMediaQuery({ query: '(pointer: fine)' });
  return Platform.OS !== 'web' || !fine;
}
